export default __webpack_public_path__ + "static/main6-72709956d56fa90aab7789f99d1b3fd6.png";